import { Box, Typography, IconButton } from "@mui/material"
import React, { useState } from "react"
import ReactApexChart from "react-apexcharts"
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from "react-redux"
import { useAppDispatch } from "../../store";
import { deleteChart } from "../../store/dashboard/dasboardReducer";
import axios from "axios";
import { useEffect, useRef } from "react"
import { getFilterValues } from "../../utils/getFilterValues"
import { logOut } from "../../utils/logOut";
import TranslatedText from "../../utils/Translate"
import { useSnackbar } from "../../utils/SnackbarContext";

export default function Chart({ name, type, data, fields, reportType, interval, params, realTime, dateInterval, setEditChartConfig, handleClickOpenDialog }) {
  console.log(params);
  console.log(reportType)

  const requestControllerRef = useRef(null);

  // Создаем копию params, чтобы не модифицировать исходный массив
  let updatedParams = [...params];

  const { showSnackbar } = useSnackbar();


  // Теперь используем updatedParams вместо исходного params для запроса


  //Get Current date fnc
  function getCurrentDateTime() {
    const currentDate = new Date();

    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    const formattedDateTime = `${formattedDay}-${formattedMonth}-${year} ${formattedHours}:${formattedMinutes}`;

    return formattedDateTime;
  }

  const [intervalId, setIntervalId] = useState(null);


  //Get selected chart config
  function getValuesByKey(key, array) {
    const values = [];
    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null || obj[key] === undefined) {
          values.push('...');
        } 
        else
        values.push(obj[key]);
      }
    }
    return values;
  }

  const [anchorEl, setAnchorEl] = React.useState(false);
  const [chartData, setChartData] = React.useState({
    labels: [],
    values: []
  });

  const dispatch = useAppDispatch()
  const charts = useSelector((state) => state.dashboard.charts)
  const open = Boolean(anchorEl);
  //Open modal
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //Close modal
  const handleClose = () => {
    setAnchorEl(false);
  };

  //Om Edit Chart
  const handleEdit = () => {
    setEditChartConfig({ name, type, data, fields, reportType, interval, params, realTime, dateInterval, beforeName: name })
    setAnchorEl(false);
    handleClickOpenDialog()
  }
  //On delete Chart
  const handleDelete = () => {
    dispatch(deleteChart(name))
    setAnchorEl(false);
  };

  let updatedLabels = [];
  let updatedValues = chartData.values;

  //Get chart data
  async function fetchData(params = {}) {

    // 1. if there is an unfinished request, cancel it
    if (requestControllerRef.current) {
      requestControllerRef.current.abort();
    }

    // 2. Create a new controller for the new request
    const controller = new AbortController();
    requestControllerRef.current = controller;

    if (dateInterval && typeof dateInterval === 'string' && dateInterval !== '') {
      const now = new Date();
      const fromDate = new Date(now);

      if (/^\d+m$/.test(dateInterval)) {
        // Минуты
        const minutes = parseInt(dateInterval.replace('m', ''), 10);
        fromDate.setTime(now.getTime() - minutes * 60 * 1000);
      } else if (/^\d+h$/.test(dateInterval)) {
        // Часы
        const hours = parseInt(dateInterval.replace('h', ''), 10);
        fromDate.setTime(now.getTime() - hours * 60 * 60 * 1000);
      } else if (/^\d+w$/.test(dateInterval)) {
        // Недели
        const weeks = parseInt(dateInterval.replace('w', ''), 10);
        fromDate.setTime(now.getTime() - weeks * 7 * 24 * 60 * 60 * 1000);
      } else if (/^\d+mon$/.test(dateInterval)) {
        // Месяцы
        const months = parseInt(dateInterval.replace('mon', ''), 10);
        fromDate.setMonth(now.getMonth() - months);
      }

      // Дата "до" (toDate) – текущая дата + 1 день
      const toDate = new Date(now);
      toDate.setDate(now.getDate());

      // Функция для форматирования даты
      function formatDateTime(dateObj) {
        const day = dateObj.getDate();
        const month = dateObj.getMonth() + 1;
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedHours = hours < 10 ? `0${hours}` : hours;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}`;
      }

      const formattedFrom = formatDateTime(fromDate);
      const formattedTo = formatDateTime(toDate);

      // Формируем объект фильтрации по датам в зависимости от reportType
      const dateFilter =
        reportType === 'conversationreport'
          ? {
            name: "Conversation date",
            params: [
              { type: "df", label: "Conversation date from", value: formattedFrom, input: "datetime" },
              { type: "dt", label: "Conversation date to", value: formattedTo, input: "datetime" },
            ],
          }
          : {
            name: "Call date",
            params: [
              { type: "calldatefrom", label: "Call date from", value: formattedFrom, input: "datetime" },
              { type: "calldateto", label: "Call date to", value: formattedTo, input: "datetime" },
            ],
          };

      // Определяем имя фильтра
      const filterName = reportType === 'conversationreport' ? "Conversation date" : "Call date";

      // Находим индекс существующего фильтра по дате в копии массива
      const dateFilterIndex = updatedParams.findIndex(p => p.name === filterName);

      if (dateFilterIndex !== -1) {
        // Если фильтр уже есть, создаем новый массив с изменённым объектом
        updatedParams = updatedParams.map(p =>
          p.name === filterName ? dateFilter : p
        );
      } else {
        // Если фильтр отсутствует – добавляем его в копию массива
        updatedParams = [...updatedParams, dateFilter];
      }
    }
    try {
      const response = await axios.get(`https://cardgarantsales.com/restapi/${reportType ? reportType : 'call'}`, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + localStorage.getItem('access_token')
        },
        params: getFilterValues(updatedParams),
        signal: controller.signal,
      })

      requestControllerRef.current = null;

      if (response.data !== null) {
        if (typeof (response.data) === 'object') {
          const newTimestamp = getCurrentDateTime();
          const newValue = getValuesByKey(fields[1], data == 'all' ? response.data : response.data.filter((e, i) => data.includes(i))).map(Number)[0];
          console.log(newValue);



          if (realTime) {
            updatedLabels = [...updatedLabels, newTimestamp].slice(-4);
            updatedValues = [
              ...updatedValues,
              type !== 'bar' && type !== 'line' && type !== 'area' && type !== 'radar'
                ? newValue
                : newValue,
            ].slice(-4);
          } else { 
            updatedLabels = getValuesByKey(fields[0], data == 'all' ? response.data : response.data.filter((e, i) => data.includes(i)));
            updatedValues = [
              ...updatedValues,
              type !== 'bar' && type !== 'line' && type !== 'area' && type !== 'radar'
                ? newValue
                : newValue,
            ];
          }
          
          console.log(updatedLabels);
          console.log(updatedValues);



          if (!updatedLabels.includes(null)) {
            setChartData({
              labels: updatedLabels,
              values: type !== 'bar' && type != 'line' && type != 'area' && type != 'radar' ? getValuesByKey(fields[1], data == 'all' ? response.data : response.data.filter((e, i) => data.includes(i))).map(Number) :
                [{
                  data: realTime ? updatedValues : getValuesByKey(fields[1], data == 'all' ? response.data : response.data.filter((e, i) => data.includes(i))).map(Number)
                }]
            })
            setState({ ...state, options: { ...state.options, labels: realTime ? updatedLabels : getValuesByKey(fields[0], data == 'all' ? response.data : response.data.filter((e, i) => data.includes(i))) } })
          }

        }
        else showSnackbar('Error: Unable to retrieve chart data', 'error');
      }
    } catch (error) {
      console.log(error);
      if (error.code === "ERR_BAD_REQUEST") {
        logOut(dispatch)
      }
      else if (error.code === "ERR_NETWORK") {
        console.log("ERR_NETWORK")
      }
      else if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
        console.log('Previous request canceled');
        return;
      }
    }
  }

  //Onload page update charts
  useEffect(() => {
    updatedLabels = [];
    updatedValues = [];
    console.log(updatedLabels);
    console.log(updatedValues);
    console.log(updatedParams)
    fetchData(updatedParams);

    // Сброс старого интервала, если он есть
    if (intervalId) {
      clearInterval(intervalId);
    }

    // Запуск нового интервала
    const newIntervalId = setInterval(() => {
      fetchData(updatedParams);
    }, Number(interval));
    setIntervalId(newIntervalId);

    // Очистка интервала при размонтировании компонента
    return () => {
      if (newIntervalId) {
        clearInterval(newIntervalId);
      }
      if (requestControllerRef.current) {
        requestControllerRef.current.abort();
      }
    };
  }, [name, type, data, fields, reportType, realTime, interval, params, dateInterval]);


  //Apex Chart config state
  const [state, setState] = useState({

    series: [1, 20, 23, 20],
    options: {
      chart: {
        width: 280,
        type: type,
        toolbar: {
          show: false
        },
        animations: {
          enabled: true,
          easing: 'linear',
          dynamicAnimation: {
            speed: 500
          }
        }
      },
      dataLabels: {
        enabled: true,
        // formatter: function(val, { seriesIndex, w }) {
        //   return w.globals.series[seriesIndex];
        // },


        dropShadow: {
          enabled: false,
          left: 1,
          top: 1,
          opacity: 0.4
        }
      },
      stroke: {
        curve: 'smooth'
      },
      labels: ["loading...", "loading...", "loading...", "loading..."],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      legend: {
        position: 'bottom',
        offsetY: 0,

      }
    },

  })
  return (
    <Box sx={{ width: 440, borderRadius: 2, boxShadow: "2px 10px 10px #f4f6f8", border: '2px solid #f4f6f8' }}>
      <Box sx={{ padding: "15px 20px", display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6">{name}</Typography>
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          color="inherit">
          <DragIndicatorIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleEdit}><TranslatedText text="Edit" /></MenuItem>
          <MenuItem sx={{ color: 'red' }} onClick={handleDelete}><TranslatedText text="Delete" /></MenuItem>
        </Menu>
      </Box>
      <ReactApexChart key={name + type + params + realTime + dateInterval} options={state.options} series={chartData.values.length !== 0 ? chartData.values : [100, 100, 100, 100]} type={type} />
    </Box>
  )
}